import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-email-verification',
  styleUrls: ['./email-verification.component.scss'],
  templateUrl: './email-verification.component.html',
})
export class EmailVerificationComponent implements OnInit {

  public isSuccessful = false;
  public errorMessage: string;
  private token: string;

  constructor(private httpClient: HttpClient, private activatedRoute: ActivatedRoute) {
    this.activatedRoute.queryParams
      .subscribe((params) => {
          this.token = params.token;
      });
  }

  public ngOnInit(): void {
    this.httpClient.get(`${environment.backendApiUrl}/v1/users/email/verify?token=` + this.token)
      .subscribe({
        next: () => {
          this.isSuccessful = true;
        },
        error: (err) => {
          this.isSuccessful = false;
          this.errorMessage = err.error.message;
       }
      });
  }

}
